import React, { FC } from 'react';
import i18n from 'i18n';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';

interface PrivateModalProps extends ModalProps {}

export const PrivateModal: FC<PrivateModalProps> = ({ app, onCancel, onSuccess }) => (
  <Dialog
    show={true}
    id="PrivateModal"
    title={i18n('component.PrivateModal.Title')({ type: app.type })}
    message={i18n('component.PrivateModal.Content')({ type: app.type })}
    onDismiss={onCancel}
    actions={[
      {
        text: i18n('component.PrivateModal.CancelText')(),
        onClick: onCancel,
        variant: 'text',
        id: 'private-button-cancel'
      },
      {
        text: i18n('component.PrivateModal.InstallText')(),
        onClick: onSuccess,
        variant: 'filled',
        id: 'install-private-button-ok'
      }
    ]}
  />
);
